import { createFileRoute } from "@tanstack/react-router";
import { HubSeoContent } from "@/components/seo/HubSeoContent";
import { Research } from "@/lib/lazyPages";
import { SEO, breadcrumbJsonLd } from "@/config/seoConfig";
import { seoHead } from "@/lib/seo/head";

export const Route = createFileRoute("/research/")({
  head: () => seoHead({
    ...SEO.research,
    pageType: "CollectionPage",
    jsonLd: [breadcrumbJsonLd([
      { name: "Home", url: "/" },
      { name: "Research", url: "/research" },
    ])],
  }),
  component: () => <><Research /><HubSeoContent hub="research" /></>,
});
